<form clrStepper [formGroup]="projectForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Projektdaten</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content>
      <!--<clr-input-container>
        <input clrInput type="hidden" formControlName="cid" />
      </clr-input-container>-->
      <clr-input-container>
        <label>Projektname</label>
        <input clrInput name="name_project" formControlName="name_project" /> 
        <clr-control-error *clrIfError="'required'">Projektname muss angegeben werden</clr-control-error>
        <clr-control-error *clrIfError="'maxLength', error as err">Projektname zu lang (max. {{ err.name_projectLenght}} Zeichen)</clr-control-error>
      </clr-input-container>

      <clr-input-container>
        <label>Kurzbeschreibung</label>
        <input clrInput formControlName="description" /> 
      </clr-input-container>
      <clr-input-container>
        <label>Anfrage-Nr. des Kunden</label>
        <input clrInput formControlName="request_id" /> 
      </clr-input-container>
      <clr-input-container>
        <label>CRM-ID</label>
        <input clrInput formControlName="crm_id" />
        <clr-control-helper>TecArt-Projektnummer. Leer lassen entfernt den CRM-Bezug.</clr-control-helper>
      </clr-input-container>
      <clr-number-input-container>
        <label>VK netto (in Euro)</label>
        <input clrNumberInput formControlName="budget" type="number" /> 
      </clr-number-input-container>
      <clr-select-container>
        <label>Projektstatus</label>
        <select clrSelect formControlName="status">
          <option value="requested">Projekt</option>
          <option value="lost">Verloren</option>
          <option value="confirmed">Auftrag</option>
          <option value="running">In Arbeit</option>
          <option value="invoiced">Berechnet</option>
          <option value="finished">Erledigt</option>
        </select>
      </clr-select-container>
      <clr-date-container>
        <label>Projektstart</label>
        <input clrDate type="date" placeholder="{{ projectsData?.start_project | date: 'dd.MM.yyyy' }}" formControlName="start_project" />
      </clr-date-container>
      <clr-date-container>
        <label>Projektende</label>
        <input clrDate type="date" placeholder="{{ projectsData?.end_project | date: 'dd.MM.yyyy' }}" formControlName="end_project" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" *ngIf="!isUpdateMode" [disabled]="projectForm.invalid" (click)="createProject()">Weiter</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" [routerLink]="['/contact/details', companyId]">abbrechen</button>
        <button class="btn" clrStepButton="next" *ngIf="isUpdateMode" [disabled]="projectForm.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/project/details', companyId, projectId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Projektverantwortlicher</clr-step-title>
    <clr-step-description>(seitens unserer Firma)</clr-step-description>
    <clr-step-content>
      <div *ngIf="devMode"><span>Projektnummer {{ companyId }}.{{ projectId }}</span> <span *ngIf="crmMode"> (CRM-Projekt: {{ internalCrmId }}) </span></div>
      <div *ngIf="devMode">Projektleader {{ projectLeader() }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label *ngIf="employee.staff_id !== projectLeader()">{{ employee.firstname }} {{ employee.lastname }}</label>
          <label *ngIf="employee.staff_id === projectLeader()" class="leader"><b>{{ employee.firstname }} {{ employee.lastname }}</b></label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="projectForm.invalid">Weiter</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" (click)="deleteProject()">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/project/details', companyId, projectId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Projektpartner</clr-step-title>
    <clr-step-description>(seitens Kunden)</clr-step-description>
    <clr-step-content>
      <clr-select-container>
        <label>Projektpartner</label>
        <select clrSelect formControlName="employee_leader">
          <option value="">Bitte wählen...</option>
          <option *ngFor="let person of persons" [value]="person.pid">{{ person.lastname }}, {{ person.firstname }}</option>
        </select>
      </clr-select-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" (click)="updateProject()">{{ isUpdateMode ? 'Aktualisieren' : 'Speichern' }}</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" (click)="deleteProject()">abbrechen</button>
        <button class="btn" *ngIf="isUpdateMode"  [routerLink]="['/project/details', companyId, projectId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode" class="datepicker-output">
  <span>Editing {{ isUpdateMode }}</span>
  <span>CRM {{ crmMode }}</span>
  <span>PHM {{ employeePhm }}</span>
  <span>Kunde {{ employeeLeader }}</span>
</pre>

<pre *ngIf="devMode" class="datepicker-output">
  <h4>Project form (projectForm):</h4>
  {{ projectForm.value | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    <h4>projectsData from Input()):</h4>
  {{ projectsData | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    <h4>Project form (newProject):</h4>
    {{ newProject | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    <h4>Project form (currentProject):</h4>
    {{ currentProject | json }}
</pre>
